// extracted by mini-css-extract-plugin
module.exports = {"container":"insightDetails_container__MUFrd","no-touch":"insightDetails_no-touch__jnna_","message":"insightDetails_message__jIjON"};